import * as React from 'react';
import { isNil } from 'lodash';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { __t, applyTranslations } from 'utils/language';

import './mention-card-location.scss';

applyTranslations(require('./mention-card-location.i18n.json'));

type Props = {
  location: string | undefined | null
};

class MentionCardLocation extends React.PureComponent<Props> {
  renderIcon(): React.ReactNode {
    return (
      <SVGDynamicIcon
        name="drop-pin-custom-fg"
        width={16}
        height={16}
        customColor="grey"
      />
    );
  }

  render(): React.ReactNode {
    const { location } = this.props;

    if (isNil(location)) {
      return null;
    }

    return (
      <div
        title={`${__t('mention_card_location.label')}: ${location}`}
        className="mention-card-location"
        data-qa="mention-card-location"
      >
        <div className="mention-card-location__icon">
          {this.renderIcon()}
        </div>
        <div className="mention-card-location__value text-overflow-ellipsis">
          {location}
        </div>
      </div>
    );
  }
}

export default MentionCardLocation;
